<template>
  <div>
    <h1>Depositing to WSB</h1>

    <BackButton
      text="Back to Deposit Menu"
      @click="backmenu"
    />

    <p>
      <img src="/icons/ottvoucher.png" alt="OTT Voucher Logo" style="height: 24px; vertical-align: middle; margin-right: 6px;">
      OTT Voucher Deposit.<br>
      Enter your OTT Voucher PIN to deposit funds.<br>
      Hello user: <a>{{ username }}</a>
    </p>

    <!-- Formulario de voucher -->
    <div v-if="showDepositForm" class="voucher-container">
      <div class="voucher-form">
        <label for="voucherPin" class="voucher-label">Voucher PIN</label>
        <input
          id="voucherPin"
          v-model="voucherPin"
          type="text"
          class="voucher-input"
          :class="{ 'input-error': showError }"
          placeholder="Enter your OTT Voucher PIN"
          :disabled="isLoading"
          maxlength="32"
          autocomplete="off"
          @keyup.enter="submitDeposit"
        />
        <span v-if="showError" class="error-msg">Please enter a valid voucher PIN (min. 4 characters).</span>

        <button
          class="deposit-btn"
          @click="submitDeposit"
          :disabled="isLoading || !voucherPin.trim()"
        >
          <span v-if="isLoading" class="spinner"></span>
          <span v-if="isLoading">Processing...</span>
          <span v-else>Redeem Voucher</span>
        </button>
      </div>
    </div>

    <!-- Mensaje de respuesta -->
    <ResponseMessage
      :message="responseMessage"
      :type="responseType"
    />

    <div class="finaltext">
      <p v-if="responseMessage && responseType === 'success'">
        Your deposit should be on your account in a few seconds.
        If your deposit doesn't appear in your WSB balance in 5 seconds,<br>
        please <a href="javascript:void(0)" @click="redirectContact">CLICK HERE</a> to contact us to let us know.
      </p>
      <p v-else-if="!responseMessage || responseType !== 'success'">
        After redeeming your OTT Voucher, your deposit will appear on your wsbetting.co.ls account.
        Please allow a few seconds for this to happen.<br>
        <a>Note</a>: Each voucher PIN can only be used once.
      </p>
    </div>
  </div>
</template>

<script>
import common from '@/scripts/common.js';
import BackButton from '@/components/BackButton.vue';
import ResponseMessage from '@/components/ResponseMessage.vue';

export default {
  components: {
    BackButton,
    ResponseMessage
  },
  data() {
    return {
      username: this.$route.query.username || "Unknown User",
      voucherPin: "",
      showError: false,
      responseMessage: "",
      responseType: "",
      showDepositForm: true,
      isLoading: false,
      apiUrl: process.env.VUE_APP_API_URL_OTT_VOUCHER
    };
  },
  methods: {
    backmenu() {
      this.$router.push({
        name: 'DepositWebsiteLesotho',
        query: { username: this.$route.query.username }
      });
    },

    redirectContact() {
      window.parent.postMessage({ action: 'btncontact' }, '*');
    },

    async submitDeposit() {
      const pin = this.voucherPin.trim();

      if (!pin || pin.length < 4) {
        this.showError = true;
        return;
      }

      this.showError = false;
      this.isLoading = true;

      const data = {
        username: this.username,
        voucher_pin: pin
      };

      try {
        const response = await fetch(`${this.apiUrl}/api/deposit/redeem`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || "Unknown error occurred");
        }

        if (result.code === 0) {
          this.responseMessage = "<h2>Deposit Successful!</h2>Your OTT Voucher has been redeemed successfully.";
          this.responseType = "success";
          this.showDepositForm = false;
        } else {
          this.responseMessage = "Redemption failed: " + result.message;
          this.responseType = "error";
          this.showDepositForm = false;
        }

      } catch (error) {
        console.error("Error redeeming voucher:", error);
        this.responseMessage = "Error redeeming voucher: " + error.message;
        this.responseType = "error";
        this.showDepositForm = false;
      } finally {
        this.isLoading = false;
      }
    },

    sendHeight() {
      const height = document.body.scrollHeight;
      window.parent.postMessage({ iframeHeight: height }, "*");
    }
  },

  async mounted() {
    var maintenance = await common.checkMaintenanceLS("ottvoucher");

    if (maintenance) {
      this.$router.push({
        name: 'DepositMaintenanceLesotho',
        query: { username: this.$route.query.username }
      });
    }

    this.sendHeight();
    window.addEventListener("resize", this.sendHeight);
  },

  updated() {
    this.$nextTick(() => {
      this.sendHeight();
    });
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.sendHeight);
  }
};
</script>

<style scoped>
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1 {
  color: #1a2332;
  text-align: center;
  font-weight: 800;
  padding: 25px 15px;
  font-size: 32px;
  margin-bottom: 10px;
  letter-spacing: -1px;
}

p {
  color: #555;
  text-align: center;
  font-size: 15px;
  line-height: 1.6;
  margin: 10px 0;
}

p a {
  color: #1a73e8;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

p a:hover {
  color: #1557b0;
  text-decoration: underline;
}

/* Voucher form container */
.voucher-container {
  display: flex;
  justify-content: center;
  padding: 30px 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.voucher-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.voucher-label {
  font-size: 14px;
  font-weight: 700;
  color: #1a2332;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  align-self: flex-start;
}

.voucher-input {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 16px;
  font-family: 'Courier New', monospace;
  letter-spacing: 2px;
  color: #1a2332;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  box-sizing: border-box;
  outline: none;
}

.voucher-input:focus {
  border-color: #7b1fa2;
  box-shadow: 0 0 0 3px rgba(123, 31, 162, 0.15);
}

.voucher-input.input-error {
  border-color: #c62828;
  box-shadow: 0 0 0 3px rgba(198, 40, 40, 0.15);
}

.voucher-input:disabled {
  background: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.error-msg {
  color: #c62828;
  font-size: 13px;
  align-self: flex-start;
}

.deposit-btn {
  width: 100%;
  padding: 14px 20px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #7b1fa2 0%, #4a148c 100%);
  color: white;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 4px 14px rgba(123, 31, 162, 0.35);
}

.deposit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(123, 31, 162, 0.45);
}

.deposit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.deposit-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Loading spinner */
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.finaltext {
  padding: 10px 16px;
  display: block;
}

@media (max-width: 480px) {
  .voucher-form {
    padding: 24px 18px;
  }

  h1 {
    font-size: 26px;
  }
}
</style>
